export const environment = {
  production: true,
  API_URL: "https://portalmedicaltgsecuiesc.atlasmed.ro/api/",
  VERSION: "1.3.4",
  VERSION_DATE: "04.06.2025",
  customInterface: true,
};